import React, { useState } from "react";
import Button from "@mui/material/Button";
import {
  Dialog,
  OutlinedInput,
  Typography,
  Stack,
  Box,
  DialogTitle,
  IconButton,
} from "@mui/material";
import DialogContent from "@mui/material/DialogContent";
import "./index.scss";
import { useTranslation } from "react-i18next";
import CloseIcon from "@mui/icons-material/Close";
import DoneIcon from "@mui/icons-material/Done";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import { Images } from "../../assets/common";
import Loader from "../Loader";
import { useEffect } from "react";

export default function LivestreamPayPopup(props) {
  const { t } = useTranslation("common");
  const [amount, setAmount] = React.useState("");
  const [value, setValue] = useState("moonPay");

  useEffect(() => {
    setAmount("");
    // setValue("");
  }, [props.open]);

  const handleChange = (e) => {
    setValue(e);
  };

  return (
    <div>
      <Dialog
        open={props.open}
        keepMounted
        // onClose={(props.handleClose, setValue(""))}
        onClose={() => {
          props.handleClose();
          setAmount("");
          setValue("moonPay");
        }}
        PaperProps={{
          style: {
            position: "relative",
            backgroundColor: "#090909",
            boxShadow: "none",
            color: "#000000",
            borderRadius: 16,
            paddingBottom: "16px",
            // width: props.onlyPayPal ? "auto" : "33%",
            backgroundImage: "none",
          },
        }}
        aria-describedby="alert-dialog-slide-description"
      >
        <Stack spacing={1}>
          <DialogTitle
            color="default"
            sx={{
              padding: "16px",
              color: "#ffffff",
              fontSize: "20px",
              borderBottom: "1px solid #1E1E1E",
            }}
          >
            {t("buySikiTokens")}
            <IconButton
              aria-label="close"
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
              }}
              onClick={() => {
                props.handleClose(false);
                setAmount("");
                setValue("moonPay");
              }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>

          <Stack sx={{ padding: "16px", borderBottom: "1px solid #1E1E1E" }}>
            <Typography className="fs-14" mb="5px !important">
              {t("liveStreamPayPopup.text2")}
            </Typography>
            <DialogContent sx={{ padding: 0 }}>
              <Box
                style={{
                  borderRadius: "25px",
                  border: "1px solid gray",
                  padding: "16.5px 14px",
                  backgroundColor: "#1E1E1E",
                }}
              >
                <Stack direction={"row"}>
                  <input
                    value={amount}
                    type="number"
                    onChange={(e) => setAmount(e.target.value)}
                    onKeyDown={(e) =>
                      ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()
                    }
                    style={{
                      border: "none",
                      minWidth: "200px",
                      width: "90%",
                      backgroundColor: "transparent",
                      color: "#ffffff",
                    }}
                    placeholder={
                      value == "payPal" || props.onlyPayPal
                        ? "Min. 4.99$"
                        : "Min. 30$"
                    }
                    autoFocus
                  />
                  <Typography
                    style={{
                      color: "gray",
                      fontSize: "12px",
                    }}
                    variant="body2"
                  >
                    USD
                  </Typography>
                </Stack>
              </Box>
            </DialogContent>
            {amount &&
            amount < 30 &&
            value !== "payPal" &&
            !props.onlyPayPal ? (
              <Typography
                variant="body2"
                sx={{ fontSize: "12px" }}
                mt={1}
                color="error"
              >
                {t("addSikiModal.text1")}
              </Typography>
            ) : (amount && amount < 4.99) ||
              (props.onlyPayPal && amount && amount < 4.99) ? (
              <Typography
                variant="body2"
                sx={{ fontSize: "12px" }}
                mt={1}
                color="error"
              >
                Minimum amount is 4.99
              </Typography>
            ) : amount && amount > 20000 ? (
              <Typography
                variant="body2"
                sx={{ fontSize: "12px" }}
                mt={1}
                color="error"
              >
                {t("addSikiModal.text3")}
              </Typography>
            ) : null}

            {props.onlyPayPal ? null : (
              <Stack sx={{ marginTop: "20px" }}>
                <Typography className="fs-14" variant="body1" color="default">
                  {t("liveStreamPayPopup.text4")}
                </Typography>

                <RadioGroup
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    color: "white",
                    marginTop: "12px",
                  }}
                  aria-labelledby="currency type"
                  name="select token type"
                  value={value}
                  // onChange={handleChange}
                >
                  <FormControlLabel
                    onClick={() => handleChange("moonPay")}
                    value="moonPay"
                    control={
                      <div
                        style={{
                          width: "17px",
                          height: "17px",
                          borderRadius: "50%",
                          border: "1px solid #999999",
                          margin: "10px",
                        }}
                      >
                        {value === "moonPay" ? (
                          <DoneIcon
                            sx={{
                              fill: "#000",
                              backgroundColor: "#2CF488",
                              borderRadius: "50%",
                              marginRight: "10px",
                              fontSize: "17px",
                            }}
                          />
                        ) : null}
                      </div>
                    }
                    label={
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <img
                          src={Images.moonPay}
                          alt="Image"
                          style={{
                            width: "92px",
                            height: "40px",
                            objectFit: "contain",
                          }}
                        />
                      </div>
                    }
                    sx={{
                      backgroundColor: "#171515",
                      borderRadius: "25px",
                      justifyContent: "flex-start",
                      marginLeft: "0px",
                    }}
                  />

                  <FormControlLabel
                    onClick={() => handleChange("payPal")}
                    value="payPal"
                    control={
                      <div
                        style={{
                          width: "17px",
                          height: "17px",
                          borderRadius: "50%",
                          border: "1px solid #999999",
                          margin: "10px",
                        }}
                      >
                        {value === "payPal" ? (
                          <DoneIcon
                            sx={{
                              fill: "#000",
                              backgroundColor: "#2CF488",
                              borderRadius: "50%",
                              marginRight: "10px",
                              fontSize: "17px",
                            }}
                          />
                        ) : null}
                      </div>
                    }
                    label={
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <img
                          src={Images.payPal}
                          alt="Image"
                          style={{
                            width: "92px",
                            height: "40px",
                            objectFit: "contain",
                          }}
                        />
                      </div>
                    }
                    sx={{
                      backgroundColor: "#171515",
                      borderRadius: "25px",
                      justifyContent: "flex-start",
                      marginTop: "20px",
                      marginLeft: "0px",
                    }}
                  />
                </RadioGroup>
              </Stack>
            )}
          </Stack>

          <Stack
            justifyContent="center"
            sx={{
              width: "50%",
              margin: "auto !important",
              marginTop: "8px !important",
            }}
          >
            {props.loading && !props.onlyPayPal ? (
              <Button style={{ backgroundColor: "tansparent !important" }}>
                <Loader
                  _class="__loader_inside_btn"
                  style={{ backgroundColor: "tansparent !important" }}
                />
              </Button>
            ) : (
              <Button
                onClick={() => {
                  if ((amount !== "" && value !== "") || props.onlyPayPal) {
                    props.handleSubmit(amount, value);
                  }
                }}
                title={t("liveStreamPayPopup.text5")}
                sx={{
                  height: "30px !importent",
                  fontWeight: "bold",
                }}
                variant="contained"
                color="primary"
              >
                {t("liveStreamPayPopup.text5")}
              </Button>
            )}
          </Stack>
        </Stack>
      </Dialog>
    </div>
  );
}
